import { apiService } from './api'

export interface User {
  id: string
  username: string
  display_name?: string
  image_url?: string
  created_at: string
}

export interface UserSearchResponse {
  success: boolean
  users: User[]
  query: string
  count: number
}

export const userService = {
  async searchUsers(query: string, limit: number = 10): Promise<User[]> {
    if (!query || query.length < 2) {
      return []
    }

    try {
      const response = await apiService.get<UserSearchResponse>('/auth/users/search', {
        params: { q: query, limit }
      })
      
      return response.data.users || []
    } catch (error) {
      console.error('User search failed:', error)
      return []
    }
  }
} 